import axios from 'axios';
import { setupAuthInterceptor, type AuthInterceptorHooks } from './http/interceptor';
import { Capacitor } from '@capacitor/core';

let apiInstance: ReturnType<typeof axios.create> | null = null;

export function initApi(baseURL: string, authHooks?: Partial<AuthInterceptorHooks>) {
  // Ensure baseURL is an absolute URL for native platforms
  let effectiveBaseURL = baseURL;
  
  if (Capacitor.isNativePlatform()) {
    // In native app, ensure we use absolute URL
    if (!baseURL.startsWith('http://') && !baseURL.startsWith('https://')) {
      console.warn('[vue-api] Native platform requires absolute baseURL, but got:', baseURL);
      // If baseURL is relative, we need to construct absolute URL
      // This should not happen if VITE_API_BASE_URL is properly set
    }
  }

  apiInstance = axios.create({
    baseURL: effectiveBaseURL,
    withCredentials: true, // THIS IS MANDATORY for session cookies to work
    // --- 新增以下兩行 ---
    // xsrfCookieName: 'XSRF-TOKEN',   // 這是後端 Set-Cookie 的名稱
    // xsrfHeaderName: 'X-XSRF-TOKEN', // 這是後端 Middleware 要檢查的 Header 名稱
    headers: { 
      'Content-Type': 'application/json',
      // 新增這行：這是一個常見的防禦 CSRF 手段
      // 因為攻擊者（如 <img> 或 <form>）無法自定義請求頭
      'X-Requested-With': 'XMLHttpRequest'
    },
  });

  setupAuthInterceptor(apiInstance, effectiveBaseURL, authHooks);

  return apiInstance;
}

export function api() {
  if (!apiInstance) throw new Error('API not initialized');
  return apiInstance;
}
